export const authInputSx = {
  '& .MuiOutlinedInput-root': {
    height: 40,
    borderRadius: '4px',
    '& .MuiOutlinedInput-input': {
      padding: '8px 16px',
    },
  },
};
